<template>
    <div>
        <div class="box">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="text-align: center"
                     label-position="left" label-width="0px" class="demo-ruleForm">
                <div style="text-align: center;" class=" login-container">
                    <h3 class="title">扫吧AR  经销商控制台</h3>
                    <el-form-item prop="account">
                        <el-input type="text" v-model="ruleForm.account" clearable prefix-icon="el-icon-search"
                                  auto-complete="off" placeholder="账号"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" v-model="ruleForm.password" clearable prefix-icon="el-icon-search"
                                  auto-complete="off" placeholder="密码"></el-input>
                    </el-form-item>
                    <!--    <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
                    <el-form-item style="width:100%;">
                        <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit"
                                   :loading="logining">登录
                        </el-button>
                        <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
                    </el-form-item>
                    <el-badge class="item" style="width:100%;">
                        <el-button type="primary" @click="handlePasswd"  style="float: right">忘记密码</el-button>
                    </el-badge>
                </div>
            </el-form>
        </div>
        <br/>
        <br/>
        <div style="text-align: center">
            <label>成都云上视觉科技有限公司</label><br/>
            <label>蜀ICP备18021783号</label>
        </div>
    </div>
</template>

<script>
    //import NProgress from 'nprogress'
    import $ from "jquery";
    import store from "../vuex/store";

    export default {
        data() {
            return {
                logo: '/static/u30.png',
                logining: false,
                ruleForm: {
                    account: '',
                    password: ''
                },
                rules: {
                    account: [
                        {required: true, message: '请输入账号', trigger: 'blur'},
                        //{ validator: validaePass }
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        //{ validator: validaePass2 }
                    ]
                },
                checked: true
            };
        },
        methods: {
            handleReset() {
                this.$refs.ruleForm.resetFields();
            },
            handlePasswd() {
                document.location.href = '#/passwd';
            },
            handleSubmit(ev) {
                let _this = this;
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        //_this.$router.replace('/table');
                        //this.logining = true;
                        //NProgress.start();
                        let params = {account: this.ruleForm.account, password: this.ruleForm.password};
                        let url = store.state.api + '/auth/login/account';
                        $.ajax({
                            url: url,
                            type: "post",
                            data: params,
                            cache: false,
                            async: false,
                            success(response) {
                              sessionStorage.setItem("user", JSON.stringify(response));
                              _this.$router.push({path: '/main'});
                            },
                            error: function (XMLHttpRequest, textStatus, errorThrown) {
                                _this.logining = false;
                                _this.$message({
                                    message: XMLHttpRequest,
                                    type: "error"
                                });
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }

</script>

<style lang="scss" scoped>

    .box {
        color: white;
        background: #2d3a4b;
    }

    .login-container {
        background-clip: padding-box;
        margin: 180px auto 20px;
        width: 450px;
        padding: 50px 90px;
        background: #2d3a4b;
        .title {
            font-size: xx-large;
            margin: 40px auto 20px auto;
            text-align: center;
        }
        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// Login.vue?508410b8